/**
 * Do not edit directly
 * Generated on Wed, 03 Sep 2025 18:40:30 GMT
 */

export const BorderColorControl = "#8d8d8d";
export const BorderColorDisplay = "#e1e1e1";
export const BorderColorDisabled = "#e1e1e1";
export const BorderColorDangerLight = "#fe8f7a";
export const BorderColorDangerControl = "#e72500";
export const BorderColorDangerDark = "#951800";
export const BorderColorPrimaryControl = "#546be7";
export const BorderColorPrimaryDark = "#2e40a5";
export const BorderRadiusTight = "4px";
export const BorderRadiusMain = "6px";
export const BorderRadiusOuter = "12px";
export const BorderRadiusRound = "1.5em";
export const BorderStyleMain = "solid";
export const BorderWidthMain = "1px";
export const BorderWidthHeavy = "1.5px";
export const DepthLow = "0px 1px 2px 0px rgba(39, 39, 39, 0.07)";
export const DepthMedium = "0px 1px 4px 0px rgba(39, 39, 39, 0.08), 0px 4px 6px 0px rgba(39, 39, 39, 0.01), 0px 5px 15px 0px rgba(39, 39, 39, 0.05)";
export const DepthHigh = "0px 1px 4px 0px rgba(39, 39, 39, 0.08), 0px 4px 10px 0px rgba(39, 39, 39, 0.08), 0px 8px 30px 0px rgba(39, 39, 39, 0.10)";
export const FocusOutlineColorPrimary = "#546be7";
export const FocusOutlineColorDanger = "#e72500";
export const FocusOutlineOffsetMain = "2px";
export const FocusOutlineOffsetTight = "0";
export const FocusOutlineStyle = "solid";
export const FocusOutlineWidthMain = "2px";
export const FocusOutlineWidthTight = "1px";
export const HueNeutral50 = "#f4f4f4";
export const HueNeutral100 = "#ededed";
export const HueNeutral200 = "#e1e1e1";
export const HueNeutral300 = "#cbcbcb";
export const HueNeutral400 = "#aeaeae";
export const HueNeutral500 = "#8d8d8d";
export const HueNeutral600 = "#6e6e6e";
export const HueNeutral700 = "#4b4b4b";
export const HueNeutral800 = "#383838";
export const HueNeutral900 = "#272727";
export const HueNeutralWhite = "#ffffff";
export const HueBlue50 = "#f2f3fd";
export const HueBlue100 = "#dbe0fa";
export const HueBlue200 = "#c1c9f6";
export const HueBlue300 = "#9daaf1";
export const HueBlue400 = "#7286eb";
export const HueBlue500 = "#546be7";
export const HueBlue600 = "#4C64E1";
export const HueBlue700 = "#2e40a5";
export const HueBlue800 = "#22307c";
export const HueBlue900 = "#182257";
export const HueGreen50 = "#defae7";
export const HueGreen100 = "#94f5b3";
export const HueGreen200 = "#7be09e";
export const HueGreen300 = "#59c282";
export const HueGreen400 = "#31a061";
export const HueGreen500 = "#16884a";
export const HueGreen600 = "#197f48";
export const HueGreen700 = "#0e562f";
export const HueGreen800 = "#0a4023";
export const HueGreen900 = "#072e19";
export const HueRed50 = "#fff0ee";
export const HueRed100 = "#ffd8d1";
export const HueRed200 = "#febbae";
export const HueRed300 = "#fe8f7a";
export const HueRed400 = "#fd4e2d";
export const HueRed500 = "#e72500";
export const HueRed600 = "#d92300";
export const HueRed700 = "#951800";
export const HueRed800 = "#711200";
export const HueRed900 = "#500d00";
export const HueYellow50 = "#fdfad9";
export const HueYellow100 = "#ffe01a";
export const HueYellow200 = "#f9c503";
export const HueYellow300 = "#eb9e05";
export const HueYellow400 = "#bf8004";
export const HueYellow500 = "#a16c03";
export const HueYellow600 = "#966603";
export const HueYellow700 = "#664402";
export const HueYellow800 = "#4c3302";
export const HueYellow900 = "#352401";
export const HueAccentOne50 = "#F5F2FD";
export const HueAccentOne100 = "#E4DFF1";
export const HueAccentOne200 = "#D2C2FF";
export const HueAccentOne300 = "#B89FFE";
export const HueAccentOne400 = "#9777F9";
export const HueAccentOne500 = "#8951FB";
export const HueAccentOne600 = "#6E47C9";
export const HueAccentOne700 = "#5227BE";
export const HueAccentOne800 = "#401895";
export const HueAccentOne900 = "#2B0679";
export const HueAccentTwo50 = "#FCF2E8";
export const HueAccentTwo100 = "#F7DCD6";
export const HueAccentTwo200 = "#F2C299";
export const HueAccentTwo300 = "#ED9B58";
export const HueAccentTwo400 = "#E06C07";
export const HueAccentTwo500 = "#C25608";
export const HueAccentTwo600 = "#964E1E";
export const HueAccentTwo700 = "#964E1E";
export const HueAccentTwo800 = "#50301B";
export const HueAccentTwo900 = "#3E1F09";
export const HueAccentThree50 = "#E1F7F7";
export const HueAccentThree100 = "#BCEBEA";
export const HueAccentThree200 = "#89D9D9";
export const HueAccentThree300 = "#5CBDBD";
export const HueAccentThree400 = "#269C9C";
export const HueAccentThree500 = "#008585";
export const HueAccentThree600 = "#1B6C6C";
export const HueAccentThree700 = "#255157";
export const HueAccentThree800 = "#1C3D3D";
export const HueAccentThree900 = "#12282B";
export const HueAccentFour50 = "#FFF2E6";
export const HueAccentFour100 = "#EBDFCA";
export const HueAccentFour200 = "#D6C9AD";
export const HueAccentFour300 = "#C2AB84";
export const HueAccentFour400 = "#A18A60";
export const HueAccentFour500 = "#87744D";
export const HueAccentFour600 = "#696803";
export const HueAccentFour700 = "#574931";
export const HueAccentFour800 = "#403727";
export const HueAccentFour900 = "#2E2618";
export const PalettePrimaryLighter = "#f2f3fd";
export const PalettePrimaryLight = "#9daaf1";
export const PalettePrimaryMain = "#546be7";
export const PalettePrimaryDark = "#2e40a5";
export const PalettePrimaryDarker = "#22307c";
export const PalettePrimaryText = "#4C64E1";
export const PalettePrimaryHeading = "#182257";
export const PalettePrimaryHighlight = "#dbe0fa";
export const PaletteDangerLighter = "#fff0ee";
export const PaletteDangerLight = "#fe8f7a";
export const PaletteDangerMain = "#e72500";
export const PaletteDangerDark = "#951800";
export const PaletteDangerDarker = "#711200";
export const PaletteDangerText = "#d92300";
export const PaletteDangerHeading = "#500d00";
export const PaletteDangerHighlight = "#ffd8d1";
export const PaletteWarningLighter = "#fdfad9";
export const PaletteWarningLight = "#eb9e05";
export const PaletteWarningMain = "#a16c03";
export const PaletteWarningDark = "#664402";
export const PaletteWarningDarker = "#4c3302";
export const PaletteWarningText = "#966603";
export const PaletteWarningHeading = "#352401";
export const PaletteWarningHighlight = "#ffe01a";
export const PaletteSuccessLighter = "#defae7";
export const PaletteSuccessLight = "#59c282";
export const PaletteSuccessMain = "#16884a";
export const PaletteSuccessDark = "#0e562f";
export const PaletteSuccessDarker = "#0a4023";
export const PaletteSuccessText = "#197f48";
export const PaletteSuccessHeading = "#072e19";
export const PaletteSuccessHighlight = "#94f5b3";
export const PaletteNeutralMain = "#6e6e6e";
export const PaletteNeutralDark = "#272727";
export const PaletteAlphaOpaque = "FF";
export const PaletteAlphaSemi = "BF";
export const ShadowScale0 = "0px 1px 4px rgba(29, 29, 33, 0.08), 0px 4px 6px rgba(29, 29, 33, 0.01), 0px 5px 15px rgba(29, 29, 33, 0.05)";
export const ShadowScale1 = "0px 1px 4px rgba(29, 29, 33, 0.08), 0px 4px 10px rgba(29, 29, 33, 0.08), 0px 8px 30px rgba(29, 29, 33, 0.1)";
export const Spacing0 = "0";
export const Spacing1 = "0.28571429rem";
export const Spacing2 = "0.57142857rem";
export const Spacing3 = "0.85714286rem";
export const Spacing4 = "1.14285714rem";
export const Spacing5 = "1.71428571rem";
export const Spacing6 = "2.28571429rem";
export const Spacing7 = "2.85714286rem";
export const Spacing8 = "3.42857143rem";
export const Spacing9 = "4rem";
export const TransitionDurationMain = "100ms";
export const TransitionDurationMainAsNumber = 100;
export const TransitionTimingMain = "linear";
export const TypographyColorBody = "#272727"; // Base text color used for most typography
export const TypographyColorHeading = "#272727"; // Base text color used for headings
export const TypographyColorInverse = "#ffffff"; // Inverse text color typically used on a colorful background
export const TypographyColorSupport = "#4b4b4b";
export const TypographyColorSubordinate = "#6e6e6e"; // Text color for subordinate text like captions
export const TypographyColorDisabled = "#aeaeae";
export const TypographyColorAction = "#4C64E1";
export const TypographyColorDanger = "#d92300";
export const TypographyColorSuccess = "#197f48";
export const TypographyColorWarning = "#966603";
export const TypographyFamilySystem = "'-apple-system', 'BlinkMacSystemFont', 'Segoe UI', 'Oxygen-Sans', 'Ubuntu', 'Cantarell'";
export const TypographyFamilyFallback = "'Helvetica Neue', sans-serif";
export const TypographyFamilyAeonik = "'Aeonik'";
export const TypographyFamilyInter = "'Inter'";
export const TypographyFamilyBody = "'Inter', '-apple-system', 'BlinkMacSystemFont', 'Segoe UI', 'Oxygen-Sans', 'Ubuntu', 'Cantarell', 'Helvetica Neue', sans-serif";
export const TypographyFamilyHeading = "'Aeonik', 'Inter', '-apple-system', 'BlinkMacSystemFont', 'Segoe UI', 'Oxygen-Sans', 'Ubuntu', 'Cantarell', 'Helvetica Neue', sans-serif";
export const TypographyFamilyButton = "'Aeonik', 'Inter', '-apple-system', 'BlinkMacSystemFont', 'Segoe UI', 'Oxygen-Sans', 'Ubuntu', 'Cantarell', 'Helvetica Neue', sans-serif";
export const TypographyFamilyMono = "'Roboto Mono', 'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace";
export const TypographyScale0 = "0.857rem";
export const TypographyScale1 = "1rem";
export const TypographyScale2 = "1.143rem";
export const TypographyScale3 = "1.286rem";
export const TypographyScale4 = "1.429rem";
export const TypographyScale5 = "1.571rem";
export const TypographyScale6 = "1.786rem";
export const TypographyScale7 = "2rem";
export const TypographyScale8 = "2.286rem";
export const TypographyScale9 = "2.571rem";
export const TypographyScale10 = "2.857rem";
export const TypographyScale11 = "3.214rem";
export const TypographyScale12 = "3.643rem";
export const TypographySizeBase = "87.5%";
export const TypographySizeOverline = "0.7142857143rem";
export const TypographySizeSubordinate = "0.857rem";
export const TypographySizeBody = "1rem";
export const TypographySizeHeading6 = "1.143rem";
export const TypographySizeHeading5 = "1.286rem";
export const TypographySizeHeading4 = "1.571rem";
export const TypographySizeHeading3 = "2rem";
export const TypographySizeHeading2 = "2.286rem";
export const TypographySizeHeading1 = "2.571rem";
export const TypographyStyleNormal = "normal";
export const TypographyWeightBody = "400";
export const TypographyWeightBodyBold = "600";
export const TypographyWeightHeading = "500";
export const TypographyWeightHeadingBold = "700";
export const TypographyLineHeightBody = 1.5;
export const TypographyLineHeightUi = 1.2;
export const TypographyLineHeightOverline = 1.3;
export const TypographyLineHeightHeading6 = 1.3;
export const TypographyLineHeightHeading5 = 1.3;
export const TypographyLineHeightHeading4 = 1.25;
export const TypographyLineHeightHeading3 = 1.25;
export const TypographyLineHeightHeading2 = 1.2;
export const TypographyLineHeightHeading1 = 1.2;
export const TypographyLineLengthMax = "55ch";
export const TypographyLetterSpacingOverline = ".05em";
